import { CaseReport } from "pwapi";

import { CASE_REPORT_SUCCESS } from "../actions/constants";

export interface CaseReportState {
  [key: number]: CaseReport;
}

const reducer = (
  state: CaseReportState | null = null,
  action: any
): CaseReportState | null => {
  switch (action.type) {
    case CASE_REPORT_SUCCESS:
      return {
        ...state,
        [action.payload.response.id]: action.payload.response,
      };
    default:
      return state;
  }
};

export default reducer;
